/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { useTranslations } from "@i18n/next";
import { useViewedScreen } from "@packages/analytics";
import { useRequestGift } from "@packages/sdk";
import {
  Container,
  cssMediaQueryMinWidthTablet,
  spacing,
  Text,
} from "@packages/ui";

import { GiftCardOption } from "./GiftCardOption";

const baseStyles: Interpolation = {
  marginBottom: spacing.xl,
  padding: spacing.m,
};

const titleStyles: Interpolation = {
  padding: spacing.l,
  textAlign: "center",
};

const optionsStyles: Interpolation = {
  display: "flex",
  gap: spacing.l,
  flexDirection: "column",
  [cssMediaQueryMinWidthTablet]: {
    flexDirection: "row",
  },
};

export const GiftCardClient = () => {
  const t = useTranslations();
  const { query: giftCards } = useRequestGift();

  useViewedScreen({ screen: "gift_card" });

  return (
    <Container maxWidth={true} size="m" css={baseStyles}>
      <Text size="l" type="headline" as="h2" css={titleStyles}>
        {t("gift_title")}
      </Text>
      <section css={optionsStyles}>
        {giftCards.data?.map((giftCard) => (
          <GiftCardOption key={giftCard.id} product={giftCard} />
        ))}
      </section>
    </Container>
  );
};
